import formatWithOptions from 'date-fns/fp/formatWithOptions'
import startOfMonth from 'date-fns/fp/startOfMonth'
import subYears from 'date-fns/fp/subYears'
import deLocale from 'date-fns/locale/de'
import enLocale from 'date-fns/locale/en-US'

import { DATE_FORMATS } from '../constants/date'

import { pipe } from './pipe'

const localesByCode = {
  en: enLocale,
  de: deLocale,
}

export type SupportedLocale = keyof typeof localesByCode

export const getLocale = (language?: SupportedLocale): Locale => {
  if (!language) return localesByCode.en

  return localesByCode[language]
}

export const getStartOfMonthFiveYearsAgo = (): Date => {
  return pipe(subYears(5), startOfMonth)(new Date())
}

export const toMonthAndYear = (date: Date, config: { language?: SupportedLocale } = {}): string => {
  return formatWithOptions({ locale: getLocale(config.language) || localesByCode.en })(DATE_FORMATS.LOCAL_MONTH_YEAR)(
    date
  )
}

export const toShortMonthFormat = (date: Date, config: { language?: SupportedLocale } = {}): string => {
  return formatWithOptions({ locale: getLocale(config.language) || localesByCode.en })('dd MMM. yyyy')(date)
}
